module.exports = __webpack_public_path__ + "static/media/LandingPage.0f8cf34c.webp";